<div class="chart-wrapper" #chartContainer>
  <canvas
    *ngIf="data"
    baseChart
    [data]="doughnutChartData"
    type="doughnut"
    [options]="options"
    [plugins]="plugins"
    class="chart"
  >
  </canvas>
  <div class="chart-legend" #chartLegend>
    <p class="legend-title">{{ getDetailTitle() }}</p>
    <p class="legend-score">
      {{ getDetailScore() | numberAbbreviate }}
    </p>
    <p class="legend-subtitle">Risk Activities</p>
  </div>
</div>
